import { render } from "./ClientImportModal.vue?vue&type=template&id=6d17b34a"
import script from "./ClientImportModal.vue?vue&type=script&lang=js"
export * from "./ClientImportModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__